import Marquee from 'react-fast-marquee';
import { useLang } from '@/context/LanguageContext';

export default function MarqueeRibbon() {
  const { t } = useLang();
  const items = t('marquee.items') || [];

  return (
    <div data-testid="marquee-section" className="py-12 border-y border-white/5 bg-zinc-950">
      <Marquee speed={40} gradient={false} className="overflow-hidden">
        {items.map((item, i) => (
          <span
            key={i}
            className="font-outfit text-2xl lg:text-4xl font-bold text-zinc-700 mx-8 lg:mx-16 uppercase tracking-tight"
          >
            {item}
            <span className="mx-8 lg:mx-16 text-zinc-800">/</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
